import React, {useRef,useState,useEffect,useMemo, useContext} from 'react'
import ComedyContentMore from './contentMore'
import {Link, useLocation} from 'react-router-dom'
import he from 'he'
import '../../../styles/comedyContent.css'
import Skeleton from '../skeleton'
import { Helmet } from 'react-helmet-async'
import ComedyBreadCrumb from '../comedyBreadCrumb'
import UnibotsPlayer from '../../ads/unibotsPlayer'
import { DeviceContext } from '..'
import SocialShare from '../socialShare'
import PageAds from '../../common/pageAds'


const ComedyContent = ({data}) => {

            const ssrData = data?.[0]?.contentPage || {}
            const ssrContent = ssrData?.content || {}
            const ssrContentError = ssrData?.contentError
            const ssrContentId = ssrData?.ssrContentId
            const contentIdRef= useRef(ssrContentId)
            const loc =useLocation().pathname
             let contentArray=loc.replace('.html',"").split('-')  
            let contentId=contentArray[contentArray.length-1]
            let cat_id=contentArray[contentArray.length-2]
         
           
            const [content,setContent] = useState(ssrContent)
            const [prev,setPrev] = useState(ssrData.previous)
            const [nxt,setNxt] = useState(ssrData.next)
            const [relatedContent,setRelatedContent] = useState(null)
            const [contentError,setContentError] = useState(ssrContentError)
            const [relatedContentError,setRelatedContentError] = useState(null)
            const [relLoad,setRelLoad] = useState(false)
            const [loading,setLoading] = useState(false)
            const [hydrating,setHydrating] = useState(true)
            const {mobile,setMobile,containerRef} = useContext(DeviceContext)
           
            const [adJson ,setAdJson] = useState(null)
    
             useEffect(() =>  {
                              const one = setTimeout(() => {
                              setHydrating(false) 
                              }, 500);
            
                              return () => clearTimeout(one)
            
                }, [])


               useEffect(() => {
        fetch("https://www.teluguone.com/teluguone-ssr-server/ad.php")
         .then(res => res.json())
         .then(data => setAdJson(data))
         .catch(err => console.error(err));
       }, []);                     
                      


              useEffect(()  =>  {
                                  
                             if (contentIdRef.current !== contentId) {
                                   setContent(null);          
                                   setPrev(null);
                                   setNxt(null);
                                  setLoading(true);        
                              }

                              if (ssrContent &&  contentIdRef.current === contentId)  {
                                contentIdRef.current = contentId
                                setLoading(false)
                                return;

                              }  
              
              
                              const getData = async() => {
                                  setLoading(true)
                                  setMobile(window.innerWidth > 768 ? false : true)
                                  try {
                                let response = await fetch(`https://www.teluguone.com/comedy/comedyContentSingleJson.php?content_id=${contentId}&cat_id=${cat_id}`);
                                if (!response.ok) {
                                    throw new Error('Network response was not ok');
                                }
                                let result = await response.json();
                                  const items = Array.isArray(result?.comedy_content_single)
                                        ? result.comedy_content_single
                                        : [];

                                    const content = items[0] ?? null;
                                    const navBlock1 = items[1] ?? [];
                                    const navBlock2 = items[2] ?? [];

                                    const previous =
                                        typeof navBlock1.previous_url === "string"
                                        ? navBlock1
                                        : [];

                                    const next =
                                        typeof navBlock1.next_film === "string"
                                        ? navBlock1
                                        : navBlock2 ?? [];

                                 setContent(content);
                                  setPrev(previous );
                                    setNxt( next);
                                     setLoading(false);
                                    setContentError(null)
                                     contentIdRef.current = contentId
                              
                                
                            } catch (error) {
                                console.error("Error fetching Content content:", error);
                             
                                  setContentError(error.message); 
                                  setContent({})
                                  setPrev([])
                                  setNxt([])
                                  setLoading(false);
                                 contentIdRef.current = contentId
                              
                    
                            }
                        }
                             
              
              
                              getData()
                              
              
                  },[contentId])

            
              useEffect(()  =>  {
                

                const fetchRelData = async() => {
                     
                     try {
                        let catId = cat_id.includes(',') ? cat_id.substring(0,cat_id.indexOf(',')) : cat_id
                       let res= await fetch(`https://www.teluguone.com/comedy/comedyContentCategoryJson.php?start=${0}&limit=${5}&cat_id=${catId}`);
                       if (!res.ok) throw new Error(`response Was Not Ok`);
                       let result = await res.json()
                       setRelatedContent(result.comedy_category)
                       setRelatedContentError(null)
                       setRelLoad(false) 
                     } catch (error) {
                          setRelatedContent(null)
                          setRelatedContentError(error.message)
                          setRelLoad(false) 
                     }
                }


                if (cat_id)  {
                    setRelatedContent(null)
                    setRelLoad(true)
                    fetchRelData()
                }
                 

              },[cat_id])



                function getCatName(cid) {
               let id = String(cid).includes(",") ? cid.substring(0,cid.indexOf(',')) : cid  
                let catname = ''
                      if(Number(id) === 1168) catname ="Facebook Fun" 
                      if(Number(id) === 80) catname ="Comedy" 
                      if(Number(id) === 23) catname ="Jokes" 
                      if(Number(id) === 640) catname ="Brahmanandam Jokes" 
                      if(Number(id) === 1135) catname ="Three-in-One" 
                      if(Number(id) === 1134) catname ="Fun Corner" 
                      if(Number(id) === 1053) catname ="My Dear Romeo" 
                      if(Number(id) === 942) catname ="Cheapey Rayudu" 
                      if(Number(id) === 941) catname ="Silly Fellow" 
                      if(Number(id) === 933) catname ="Hello Wrong Number" 
                      if(Number(id) === 654) catname ="Fun Time" 
                      if(Number(id) === 24) catname ="Audio Serial" 
                      if(Number(id) === 758) catname ="Taataadhithai Tadiginatom" 
                      if(Number(id) === 709) catname ="Aahanagar Colony" 
                      if(Number(id) === 707) catname ="Saddam Aunty Inti Katha" 
                      if(Number(id) === 669) catname ="Audio Jokes" 
                      if(Number(id) === 659) catname ="Wife and Husband Jokes" 
                      if(Number(id) === 657) catname ="General Jokes" 
                      if(Number(id) === 661) catname ="Sports Jokes" 
                      if(Number(id) === 655) catname ="Political Jokes" 
                      if(Number(id) === 660) catname ="Youth and Romantic Jokes" 
                      if(Number(id) === 658) catname ="Software and IT Jokes" 
                      if(Number(id) === 642) catname ="Shivatandavam" 
                      if(Number(id) === 641) catname ="Mallikkrazy" 
                      if(Number(id) === 623) catname ="Ammo Ammayilu" 
                      if(Number(id) === 538) catname ="Antera Bamardee" 
                      if(Number(id) === 340) catname ="Yeluka Vacche Illu Bhadram" 
                      if(Number(id) === 5) catname ="Maliks" 
                      if(Number(id) === 319) catname ="Sampurna Golayanam" 
                      if(Number(id) === 284) catname ="The Diary of LEKHA GUMMADI" 
                      if(Number(id) === 282) catname ="Audio Serial" 
                      if(Number(id) === 61) catname ="Games" 
                      if(Number(id) === 60) catname ="Rampandu Leelalu" 
                      if(Number(id) === 62) catname ="Puzzle" 
                      if(Number(id) === 3) catname ="Daily Serials" 
                      if(Number(id) === 26) catname ="Hot Shot" 
                      if(Number(id) === 27) catname ="Tingu" 
                      if(Number(id) === 34) catname ="Comedy Stories" 
                      if(Number(id) === 28) catname ="Oo Mallikanna" 
                      if(Number(id) === 25) catname ="Siggu Siggu" 
                      if(Number(id) === 29) catname ="Gura Vayanam" 
                      if(Number(id) === 20) catname ="Andaru Dongale" 
                      if(Number(id) === 6) catname ="Audio Cartoons" 
                      if(Number(id) === 21) catname ="Prema Pandem" 
                      if(Number(id) === 4) catname ="Articles"
                 return catname;
              }        




    return (
      <div className='container-fluid comedy-content-page g-0'>
            
                 <div className='row g-0'>
                  <Helmet> <title>TeluguOne - comedy | {content && content.title || "comedy News Article"}</title></Helmet>

                  <div className='col-12'>
                      <ComedyBreadCrumb breadCrumb={{one:`${content && getCatName(cat_id) || ''}`,two:`${content && content.title || ''}`} } />
                </div>
                <div className='col-12'><UnibotsPlayer /></div>
                   <div className='col-12'>
                  <div className='comedy-content-box'>
                     {!mobile &&(loading || hydrating) &&
                     <> 
                  <Skeleton type="title" />
                  <div className='comedy-main-content-box' >
                  <Skeleton type="content-square" />
                  <Skeleton type="paragraph" />
                  <Skeleton type="paragraph" />
                  <Skeleton type="paragraph" />
                  <Skeleton type="paragraph" />
                  <Skeleton type="paragraph" />
                  <Skeleton type="paragraph" />
                  <Skeleton type="paragraph" />
                  <Skeleton type="paragraph" />
                  <Skeleton type="paragraph" /><Skeleton type="paragraph" /><Skeleton type="paragraph" /><Skeleton type="paragraph" /><Skeleton type="paragraph" /><Skeleton type="paragraph" /><Skeleton type="paragraph" /><Skeleton type="paragraph" />
                  <Skeleton type="paragraph" /><Skeleton type="paragraph" /><Skeleton type="paragraph" /><Skeleton type="paragraph" /><Skeleton type="paragraph" /><Skeleton type="paragraph" />
                  <Skeleton type="paragraph" /><Skeleton type="paragraph" /><Skeleton type="paragraph" /><Skeleton type="paragraph" />
                  </div>
                   </> 
                    }
                   


                       {content &&  
                  <>
                <h1 >
                 {content && content.title  ? content.title : ''}</h1>
                 {/* <img src={content.content_img ? content.content_img : '/comedy/assets/images/error_img.webp'} className={`${hydrating ? 'ssr-hidden' : ''}`}  loading="eager" fetchpriority="high" alt="vc-img" /> */}
                 {   <div id="loading-div" className={`${hydrating ? 'ssr-hidden' : ''}`} style={{width:"100%"}}>
                          {content.audio_file && content.audio_file !== "https://www.teluguone.com/tone_cms/" &&  <audio controls preload="metadata" style={{ width: "100%" }}>
                                 <source src={content.audio_file} type="audio/mpeg" />
                                       Your browser does not support the audio element.
                           </audio>}
                          <GetTheFullDescContent data={content.description ? content.description : ''}  />
                            {contentError &&   <div className="json-loading-error-div">
                            <img loading="eager" src="/comedy/assets/images/json_error.png" alt="json_error" />
                           </div>
                          }
                           {content &&<div style={{width:"100%"}}> <SocialShare /></div> }
                 </div>}
                 </>   }


                 
                     

                  </div>



                   </div>


                 {content &&   <div className='col-12'><center> 
                    
                     {adJson && adJson.googleNewsAd?.link ? <a href={adJson?.googleNewsAd?.link} target="_blank" rel="noreferrer">
                          <img src={adJson?.googleNewsAd?.img} alt="google-ad-img" />
                          </a>
                          :
                          <a href="https://news.google.com/search?q=site:teluguone.com&hl=te&gl=IN&ceid=IN:te" target="_blank" rel="noreferrer">
                                <img src=" https://www.teluguone.com/images/g-news-banner.gif" alt="google-ad-img" />
                          </a>
                          
                          } 

                   </center></div>
                   }


                    <div className='col-12'>
            <div className='prev-next-box d-flex justify-content-between'>
              {prev && prev.previous_url ? <button type="button"><Link to={prev.previous_url.substring(prev.previous_url.lastIndexOf('/content')).replace("?","-")} >{"«"} Previous</Link></button> : <p> </p>}
              { nxt && nxt.next_film ?   <button type="button"><Link to={nxt.next_film.substring(nxt.next_film.lastIndexOf('/content')).replace("?","-")} >Next {"»"}</Link></button> : <p> </p>}
         </div>
                     </div>



                 </div>

                 <div className='row g-0'>
      
                  {(relLoad) &&    Array(4).fill("0").map((__,index)  => 
                                <div className='col-12 col-md-3 col-sm-4' key={index}>  
                                  <div className='comedy-contentpage-card'>
                                   <div className='mob-skelton-img'>
                                   <Skeleton type="square" />
                                   </div>
                                    
                                  <div className='mob-skeleton-desc'>
                                    <Skeleton type="title" />
                                    <Skeleton type="paragraph" />
                                    <Skeleton type="paragraph" />
                                    <Skeleton type="paragraph" />
                                </div>    
                                 </div>
                                </div>
                  )}
                  

                {relatedContent && <h1 className='related-posts-heading'>Related posts</h1>}
                {relatedContent && <ComedyContentMore data={relatedContent} contentId={contentId} mobile={mobile}  /> }
                   {relatedContentError &&     <div className='col-12'>
                        <div className="json-loading-error-div">
                            <img loading="eager" src="/comedy/assets/images/json_error.png" alt="json_error" />
                       </div>
                        </div>   }
                 </div>
           
               <PageAds  mobile={mobile} containerRef={containerRef} />  
      </div>
    )
  }
  
  export default ComedyContent;



  const GetTheFullDescContent = ({ data }) => {
  const baseURL = "https://www.teluguone.com";
  // const containerRef = useRef(null);

  // Replace relative URLs
  const fixedData = useMemo(() => {
    if (!data) return '';
    return data
      .replace(/src="\/teluguoneUserFiles/g, `src="${baseURL}/teluguoneUserFiles`)
      .replace(/src="\/tonecmsuserfiles/g, `src="${baseURL}/tonecmsuserfiles`);
  }, [data]);

  return (

     <div className='comedy-main-content-box'  dangerouslySetInnerHTML={{__html : fixedData ?  he.decode(fixedData) : '' }}></div> 
  )

}


